/** Has to match spring.servlet.multipart.max-file-size in ps-server, which rejects anything larger. */
export const MAX_UPLOAD_SIZE_MB = 250;
